module.exports = __webpack_public_path__ + "static/img/mobile_banner.0941a250.png";